var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 13.3525V16.165C11.125 16.6828 10.7053 17.1025 10.1875 17.1025H2.0625C1.54473 17.1025 1.125 16.6828 1.125 16.165V5.54004C1.125 5.02227 1.54473 4.60254 2.0625 4.60254H3.625C4.05089 4.60254 4.46849 4.63804 4.875 4.70624M11.125 13.3525H13.9375C14.4553 13.3525 14.875 12.9328 14.875 12.415V8.35254C14.875 4.63629 12.1721 1.55133 8.625 0.956237C8.21849 0.888038 7.80089 0.852539 7.375 0.852539H5.8125C5.29473 0.852539 4.875 1.27227 4.875 1.79004V4.70624M11.125 13.3525H5.8125C5.29473 13.3525 4.875 12.9328 4.875 12.415V4.70624M14.875 10.2275V8.66504C14.875 7.11174 13.6158 5.85254 12.0625 5.85254H10.8125C10.2947 5.85254 9.875 5.43281 9.875 4.91504V3.66504C9.875 2.11174 8.6158 0.852539 7.0625 0.852539H6.125",
    stroke: "#3F3F46",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.d668abfc8d5193c116d2f85f14d178ff.svg";
export { ForwardRef as ReactComponent };